import { motion, AnimatePresence } from "framer-motion";
import { Suspense } from "react";
import { useLocation } from "react-router-dom";

import { AuthCallback } from "../components";

export default function Callback() {
    const pathname = useLocation();

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={pathname.pathname}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.2 }}
                style={{ width: "100%", height: "100%" }}
            >
                <Suspense fallback={<div>Loading...</div>}>
                    <AuthCallback />
                </Suspense>
            </motion.div>
        </AnimatePresence>
    );
}
